import styled from 'styled-components'
import palette from 'theme/palette'

export const Container = styled.div`
  font-family: 'Roboto', sans-serif;
  padding: 24px;
  background: #f6f6f6;
  border-radius: 8px;
  width: 210px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;

  header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    text-align: start;

    strong {
      color: #37474f;
      font-size: 16px;
      margin-right: 8px;
    }
  }

  h1 {
    color: ${palette.primary.main};
    font-size: 22px;
    margin-top: 10px;
    margin-bottom: 0;
  }
`
